import React, { ReactNode, useMemo } from "react";
import "./InstancesList.scss";
import { TextButton } from "../../../design-system/controls";
import { Link, useRouteMatch } from "react-router-dom";

interface InstancesListIntegration {
  name?: string;
}

interface InstancesListProps {
  children?: ReactNode;
  mutateAllowed?: boolean;
  currentIntegration?: InstancesListIntegration;
}

interface InstancesListRouteParams {
  itemPath?: string;
}

const InstancesList: React.FC<InstancesListProps> = ({
  children,
  mutateAllowed = true,
  currentIntegration,
}) => {
  const { url } = useRouteMatch();
  const routeMatch = useRouteMatch<InstancesListRouteParams>(
    "/settings/:groupPath/:itemPath/:id"
  );

  const isDataSource = useMemo(
    () => routeMatch?.params?.itemPath === "dataSources",
    [routeMatch]
  );

  return (
    <div className={"integration-details-instances-wrapper"}>
      <div className={"instances-list-header"}>
        <h4>Instances</h4>
        {isDataSource && (
          <Link
            to={{
              pathname: "/policies/findings-rules/prioritization",
              state: { selectDefaultRules: true },
            }}
          >
            <TextButton
              label={"Review Default Rules"}
              data-testid={"review-default-rules"}
              buttonStyle={"textLink"}
            />
          </Link>
        )}
        {mutateAllowed && (
          <Link to={`${url}/new`}>
            <TextButton
              buttonStyle={"primary"}
              label={"+ Add Instance"}
              data-testid={"add-instance"}
              data-analytics-event="user_click"
              data-analytics-props={`{"name": "add_instance_btn", "integration": "${currentIntegration?.name}"}`}
              title={"Add Instance"}
            />
          </Link>
        )}
      </div>
      {children}
    </div>
  );
};

export default InstancesList;
